var map = {
	"./77468abd-459c-47d2-b6a1-d587fbc0aa13.jpg": 849,
	"./C82EDA9E-4E39-4024-BA8F-F47506618E63-4430-00000431C1C2FB90.jpg": 78,
	"./EMAIL008.jpg": 899,
	"./Gwen.jpg": 586,
	"./Headshot Pink November 2022.jpg": 77,
	"./IMG_8481-2_edit.jpg": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;